import { useFetchSubAccounts } from '@/containers/Accounts/api';
import { selectCurrentAccountId } from '@/lib/redux/app.selectors';
import { setSubAccountsByRoot } from '@/lib/redux/app.slice';
import { useAppDispatch } from '@/lib/redux/store';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useUser from './useUser';

/**
 * Hook to fetch and store sub-accounts for the current account
 * This runs whenever the current account changes
 */
const useInitializeFetchSubAccounts = () => {
  const dispatch = useAppDispatch();
  const { isLoggedIn } = useUser();
  const currentAccountId = useSelector(selectCurrentAccountId);

  const { isLoading, data } = useFetchSubAccounts(
    currentAccountId || undefined,
    isLoggedIn && !!currentAccountId
  );

  // Update redux when sub-accounts are fetched
  useEffect(() => {
    if (data && !isLoading && currentAccountId) {
      const subAccounts = data.data?.subs || [];

      // Update the subAccountsByRoot map with this account's subs
      dispatch(
        setSubAccountsByRoot({
          [currentAccountId]: subAccounts,
        })
      );
    }
  }, [data, dispatch, isLoading, currentAccountId]);
};

export default useInitializeFetchSubAccounts;
